module.exports = __webpack_public_path__ + "static/media/datasheet_listData_row12_certificate.fc33caff.png";